module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_general1_txt.ad10ea22adff237dffe6a6c6107483b3.png";